import React, { useState } from 'react'

export default function Billing() {

    return (
        <div>
            <span>Billing</span>
        </div>
    )
}